/**
 * @fileoverview A utility module for checking keyboard events.
 * @module getKey
 */

/**
 * Creates an object with properties to check for specific key presses in a keyboard event.
 *
 * @param {KeyboardEvent} event The keyboard event object.
 * @returns {{isTab: boolean, isShiftTab: boolean, isEscape: boolean}} An object with getter properties.
 */
export function getKey(event) {
  const { key, shiftKey } = event;

  return {
    /** 'Tab' key without 'Shift' key */
    isTab: key === 'Tab' && !shiftKey,

    /** 'Shift + Tab' combination */
    isShiftTab: key === 'Tab' && shiftKey,

    /** 'Escape' key */
    isEscape: key === 'Escape',
  };
}
